import Experience from "../Experience";
import * as THREE from "three"

export default class Environment
{
    constructor()
    {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.debug = this.experience.debug

        if(this.debug.active){
            this.debugFolderEnvironment = this.debug.gui.addFolder('Environment')
            console.log(this.debugFolderEnvironment)
        }

        this.setAmbientLight()
        this.setSunLight()
        this.setFog()
    }

    setAmbientLight()
    {
        this.ambientLight = new THREE.AmbientLight('#ffffff', 1)
        this.scene.add(this.ambientLight)
        
    }

    setSunLight()
    {
        this.sunLight = new THREE.DirectionalLight('#4DA1A9', 3)
        this.scene.add(this.sunLight)
        this.sunLight.position.set(-18, 16.5, 11)
        this.sunLight.castShadow = true
        this.sunLight.shadow.mapSize.set(1024, 1024)

        this.sunLight.shadow.camera.far = 69
        this.sunLight.shadow.camera.near = 7

        this.sunLight.shadow.camera.right = -35
        this.sunLight.shadow.camera.left = 31
        this.sunLight.shadow.camera.bottom = -12
        this.sunLight.shadow.camera.top = 25

        this.sunLight.target.position.x = 4.8
        this.sunLight.target.position.z = -1.5


        this.scene.add(this.sunLight.target)

        if(this.debug.active)
        {
            // Camera Helper
            const cameraHelper = new THREE.CameraHelper(this.sunLight.shadow.camera);
            this.scene.add(cameraHelper);

            //Tweaks
            this.debugFolderEnvironment.add(this.sunLight.shadow.camera, 'top').min(0).max(100).step(0.1).name("shadowCameraTop").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.shadow.camera, 'bottom').min(-35).max(35).step(0.1).name("shadowCameraBottom").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.shadow.camera, 'right').min(-100).max(100).step(0.1).name("shadowCameraRight").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.shadow.camera, 'left').min(-100).max(100).step(0.1).name("shadowCameraLeft").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.shadow.camera, 'far').min(0).max(100).step(0.1).name("shadowCameraFar").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })
            
            this.debugFolderEnvironment.add(this.sunLight.position, 'y').min(0).max(100).step(0.1).name("sunLightY").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.position, 'x').min(-100).max(100).step(0.1).name("sunLightX").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.position, 'z').min(-100).max(100).step(0.1).name("sunLightZ").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            this.debugFolderEnvironment.add(this.sunLight.target.position, 'x').min(-10).max(10).step(0.001).name("sunLightTargetX").onChange(() =>
            {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })

            
            this.debugFolderEnvironment.add(this.sunLight.target.position, 'z').min(-10).max(10).step(0.001).name("sunLightTargetZ").onChange(() =>
                {
                cameraHelper.update()
                this.sunLight.shadow.camera.updateProjectionMatrix();
            })
        } 
    }

    setFog()
    {
        this.scene.fog = new THREE.FogExp2('#B3C8CF', 0.03)
        if(this.debug.active)
        {
            this.debugFolderEnvironment.add(this.scene.fog, 'density').min(0).max(10).step(0.001).name("Fog")
        }
    }
}